export default __webpack_public_path__ + "static/media/teacher-performance.46982642.png";